import { PerfilComponentProps } from "../../views/authPerfil/authPerfil";

export default class PerfilContainer {
  public props: PerfilComponentProps;

  constructor(props: PerfilComponentProps) {
    this.props = props;
  }

  async AlterarPerfil(request : FormData) {
    this.props.AlterarPerfil(request)
  }
  
}
